module.exports = __webpack_public_path__ + "static/product-l0970-snow-white-dc3f884e8b604056dfec77bc5b05ef6b.png";